import React, { useState } from 'react';

const Navbar = () => {
  const [language, setLanguage] = useState('english');
  const [userLoggedIn, setUserLoggedIn] = useState(true);
  const [userName] = useState('आपले स्वागत आहे');

  // Government of Maharashtra color scheme
  const colors = {
    primary: '#003366', // Deep blue - official color
    secondary: '#FF9933', // Saffron - Maharashtra state color
    accent: '#138808', // Green - prosperity
    light: '#F5F5F5',
    white: '#FFFFFF'
  };

  const gradientStyle = {
    background: '#085e53',
  };

  const gramPanchayatInfo = {
    name: 'ग्रामपंचायत - शिवाजी नगर',
    district: 'जिल्हा: पुणे',
    taluka: 'तालुका: हवेली',
    village: 'गाव: शिवाजी नगर',
    pincode: 'पिनकोड: 411042'
  };

const handleLogout = () => {
    localStorage.removeItem('userRole');
    localStorage.removeItem('authToken');
    window.location.href = '/';
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
    // Here you would typically implement language change logic
    console.log(`Language changed to: ${e.target.value}`);
  };

  return (
    <div className="w-full h-16 shadow-lg" style={gradientStyle}>
      <div className="h-full flex items-center justify-between px-4 md:px-6">
        
        {/* Left: Government of Maharashtra Logo/Branding */}
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-lg font-bold" style={{ color: colors.primary }}>
              महा
            </span>
          </div>
          <div className="hidden md:block">
            <h1 className="text-sm font-bold text-white">महाराष्ट्र शासन</h1>
            <h2 className="text-xs text-white opacity-90">Government of Maharashtra</h2>
          </div>
        </div>

        {/* Center: Gram Panchayat Information */}
        <div className="hidden lg:flex flex-1 justify-center">
          <div className="bg-white bg-opacity-20 rounded-lg px-3 py-1.5 backdrop-blur-sm max-w-lg">
            <div className="flex items-center justify-center gap-2">
              <span className="text-sm font-semibold text-white truncate">
                {language === 'marathi' ? gramPanchayatInfo.name : 'Gram Panchayat - Inam Dhamani'}
              </span>
            </div>
          </div>
        </div>

        {/* Right Side: Language Selector, User Info and Logout */}
        <div className="flex items-center space-x-4">
          
          {/* Language Dropdown */}
          <div className="relative hidden sm:block">
            <select
              value={language}
              onChange={handleLanguageChange}
              className="px-3 py-1.5 rounded-lg bg-white bg-opacity-20 backdrop-blur-sm border border-white border-opacity-30 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 appearance-none pr-8 w-32"
              style={{ color: colors.white }}
            >
              <option value="english" className="text-gray-800">English</option>
              <option value="marathi" className="text-gray-800">मराठी</option>
            </select>
            <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          {/* Mobile Language Selector */}
          <div className="relative sm:hidden">
            <select
              value={language}
              onChange={handleLanguageChange}
              className="px-2 py-1 rounded-lg bg-white bg-opacity-20 backdrop-blur-sm border border-white border-opacity-30 text-white text-xs focus:outline-none appearance-none pr-6"
            >
              <option value="english">EN</option>
              <option value="marathi">मर</option>
            </select>
          </div>

          {/* User Info and Logout Button */}
          {userLoggedIn ? (
            <div className="flex items-center space-x-3">
              <div className="hidden md:flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                  <span className="font-bold text-sm" style={{ color: colors.primary }}>
                    {userName.charAt(0)}
                  </span>
                </div>
                <span className="text-sm font-medium text-white">
                  {language === 'marathi' ? userName : 'Welcome'}
                </span>
              </div>
              
              <div className="md:hidden">
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
                  <span className="font-bold text-sm" style={{ color: colors.primary }}>
                    {userName.charAt(0)}
                  </span>
                </div>
              </div>
              
              <button
                onClick={handleLogout}
                className="px-3 py-1.5 rounded-lg bg-white text-sm font-medium transition-all duration-300 hover:bg-opacity-90 hover:shadow-lg"
                style={{ color: colors.primary }}
              >
                <span className="hidden md:inline">
                  {language === 'marathi' ? 'बाहेर पडा' : 'Logout'}
                </span>
                <span className="md:hidden">
                  {language === 'marathi' ? 'बाहेर' : 'Out'}
                </span>
              </button>
            </div>
          ) : (
            <button
              onClick={() => setUserLoggedIn(true)}
              className="px-3 py-1.5 rounded-lg bg-white text-sm font-medium transition-all duration-300 hover:bg-opacity-90 hover:shadow-lg"
              style={{ color: colors.primary }}
            >
              <span className="hidden md:inline">
                {language === 'marathi' ? 'लॉगिन करा' : 'Login'}
              </span>
              <span className="md:hidden">
                {language === 'marathi' ? 'लॉगिन' : 'Login'}
              </span>
            </button>
          )}
        </div>
      </div>

      {/* Mobile Gram Panchayat Information */}
      <div className="lg:hidden bg-white bg-opacity-15 mx-4 mt-2 rounded-lg px-3 py-1.5 backdrop-blur-sm">
        <div className="text-center">
          <span className="text-xs font-medium text-white truncate block">
            {language === 'marathi' ? gramPanchayatInfo.name : 'Gram Panchayat - Shivaji Nagar'}
          </span>
          <div className="flex justify-center gap-1 mt-1 text-[10px] text-white opacity-90">
            <span>{language === 'marathi' ? gramPanchayatInfo.district : 'Pune'}</span>
            <span>•</span>
            <span>{language === 'marathi' ? gramPanchayatInfo.taluka : 'Haveli'}</span>
            <span>•</span>
            <span>{language === 'marathi' ? gramPanchayatInfo.pincode : '411042'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;